import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { indicatorState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";
import Loading from './../Loading';

function PaymentDetail({ match }) {
  const [, setIndicator] = useRecoilState(indicatorState);
  const [cardDetail, setCardDetail] = useState("");
  const [nickName, setNickName] = useState("");
  const submitButtonRef = useRef();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const isCard = match.params.payment === "card";
  const id = match.params.id;

  useEffect(() => {
    setIndicator("홈 > 결제수단 관리 > 결제수단 조회 및 수정");

    const getCardDetail = async () => {
      try {
        setLoading(true);
        const { data } = await awsInstance.get("/business/card", {
          params: {
            id: id,
          },
        });
        if (data.code === "SUCCESS") {
          const info = data.data;
          setCardDetail(info);
          setNickName(info.nickname);
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    };
    getCardDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFormSubmit = async (event) => {
    event.preventDefault();

    if (nickName === '') {
      alert("닉네임을 입력하세요.");
      return false;
    }
    const params = new URLSearchParams({
      id: id,
      nickname: nickName,
    });

    try {
      const { data } = await awsInstance.put(`/business/card?${params}`);
      if (data.code === "SUCCESS") {
        alert("성공적으로 수정되었습니다.");
        history.push("/payment");
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert(e);
    }
  };

  return (
    <>
    <div className="payment_detail">
      <h5>결제수단 조회 및 수정</h5>
      <form className="register-form" onSubmit={onFormSubmit}>
        <div className="display-flex justify-content-between">
          <p className="txt-gray">
            등록된 결제 수단의 상세한 정보를 확인하고 수정합니다.
            <br />
            전체 카드번호는 노출이 되지 않으며, 닉네임을 통해 부서별/용도별로
            구분하여 사용하실 수 있습니다.
          </p>
        </div>
        <table className="table table-detail">
          <tbody>
            <tr>
              <th colSpan="1" className="width-20">
                <span>구분</span>
              </th>
              <td colSpan="3" className="width-80">
                <span className="txt-dark-gray">
                  {isCard ? "카드" : "세금계산서"}
                </span>
              </td>
            </tr>
            <tr>
              <th colSpan="1">
                <span className="txt-dark-gray">닉네임</span>
              </th>
              <td colSpan="3" className="p-0 pl-2">
                <span className="txt-dark-gray mr-2 display-inline-block">
                  <input
                    type="text"
                    className="form-control pl-1"
                    value={nickName}
                    maxLength="10"
                    onChange={(e) => setNickName(e.target.value)}
                  ></input>
                </span>
              </td>
            </tr>
            {!isCard && (
              <>
                <tr>
                  <th colSpan="1">
                    <span className="txt-dark-gray">세금계산서 발행일</span>
                  </th>
                  <td colSpan="3">
                    <span className="txt-dark-gray mr-2">
                      {cardDetail && cardDetail.issued_date + "일"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th colSpan="1">
                    <span className="txt-dark-gray">입금 마감일</span>
                  </th>
                  <td colSpan="3">
                    <span className="txt-dark-gray mr-2">
                      {cardDetail.closing_date &&
                        cardDetail.closing_date + "일"}
                    </span>
                  </td>
                </tr>
              </>
            )}
            {isCard && (
              <>
                <tr>
                  <th colSpan="1">
                    <span className="txt-dark-gray">카드사</span>
                  </th>
                  <td colSpan="3">
                    <span className="txt-dark-gray">
                      {cardDetail && cardDetail.company}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th colSpan="1">
                    <span className="txt-dark-gray">카드번호</span>
                  </th>
                  <td colSpan="3">
                    <span className="txt-dark-gray">
                      {cardDetail && cardDetail.protected_number}
                    </span>
                  </td>
                </tr>
              </>
            )}
            <tr>
              <th colSpan="1">
                <span className="txt-dark-gray">등록일시</span>
              </th>
              <td colSpan="3">
                <span className="txt-dark-gray">
                  {cardDetail && cardDetail.registered_date}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="display-flex justify-content-center mt-4">
          <button className="btn-white-md mr-4" type="button" onClick={() => history.goBack()}>
            이전
          </button>
          <button className="btn-blue-md" type="submit" ref={submitButtonRef}>
            수정
          </button>
        </div>
      </form>
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default PaymentDetail;
